import React, { useEffect, useRef, useState } from 'react';
import * as styles from './Reveal.module.css';

type RevealDirection = 'left' | 'right' | 'top' | 'bottom' | 'fade' | 'zoom';

interface RevealProps {
    children: React.ReactNode;
    direction?: RevealDirection;
    delay?: number;
    duration?: number;
    className?: string;
    width?: 'fit-content' | '100%';
}

export const Reveal: React.FC<RevealProps> = ({
    children,
    direction = 'bottom',
    delay = 0,
    duration = 0.5,
    className = '',
    width = 'fit-content',
}) => {
    const [isVisible, setIsVisible] = useState(false);
    // Removed IntersectionObserver in favor of direct mount animation for Landing Page stability

    useEffect(() => {
        // Simple timeout to trigger animation after mount
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 100); // Small initial buffer

        return () => clearTimeout(timer);
    }, []);

    const getHiddenClass = () => {
        switch (direction) {
            case 'left': return styles.hiddenLeft;
            case 'right': return styles.hiddenRight;
            case 'top': return styles.hiddenTop;
            case 'bottom': return styles.hiddenBottom;
            case 'zoom': return styles.hiddenZoom;
            case 'fade': return styles.hiddenFade;
            default: return styles.hiddenBottom;
        }
    };

    return (
        <div
            className={`
                ${styles.revealContainer} 
                ${isVisible ? styles.visible : getHiddenClass()} 
                ${className}
            `}
            style={{
                width,
                transitionDuration: `${duration}s`,
                transitionDelay: `${delay}s`
            }}
        >
            {children}
        </div>
    );
};
